import React from 'react';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { getYoutubeIdFromUrl } from '../../../helpers';
import './style.scss';

const ParagraphVideo = ({ entity }) => {
  const youtubeId = getYoutubeIdFromUrl(entity.getIn(['field_video_link', 0, 'embed']));

  return (
    <Container className="Video" small>
      <div className="row">
        <div className="col-12">
          <div className="Video__wrapper">
            <div className="Video__wrapper__inner">
              <iframe src={`https://www.youtube.com/embed/${youtubeId}?rel=0`} title=" " frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ParagraphVideo;
